import Helper from './Helper';

class Accordion {
  constructor(config = {}) {
    const {
      accordions,
    } = config;
    this.accordions = Array.prototype.slice.call(document.querySelectorAll(accordions));
    this.currentEl = null;
    if(this.accordions && this.accordions.length !== 0){
      this.bindEvents();
    }
  }

  bindEvents() {
    this.accordions.forEach(el => {
      const contents = el.nextElementSibling;
      console.log(contents);
      const h2 = contents.querySelector('h2:first-child');
      const h3 = contents.querySelector('h3:first-child');
      console.log(h2);
      console.log(h3);
      if(h2){
        h2.remove();
      }
      if(h3){
        h3.remove();
      }
      el.addEventListener('click', (e) => {
        if(el.classList.contains('active')){
          Helper.slideClose(el.nextElementSibling);
          el.classList.remove('active');
        } else{
          Helper.slideOpen(el.nextElementSibling, true);
          setTimeout(function(){
            el.classList.add('active');
          }, 100);

        }
      });
    });
  }

}

export default Accordion;
